import DetailsCard from "../DetailsCard";

const DashboardSummaryCards = ({ dashBoardSummary, loading }) => {
    return (
        <div className="row">
            <div className="col-xl-4 col-sm-6">
                <DetailsCard
                    title={'Pedidos Mensuales'}
                    loading={loading}
                    icon='fa fa-box'
                    value={dashBoardSummary?.ordersCountByType?.monthly || '--'}
                    gradient="gradient-12"
                />
            </div>
            <div className="col-xl-4 col-sm-6">
                <DetailsCard
                    title={'Pedidos Extraordinarios'}
                    loading={loading}
                    icon='fa fa-box'
                    value={dashBoardSummary?.ordersCountByType?.extraordinary || '--'}
                    gradient="gradient-15"
                />
            </div>
            <div className="col-xl-4 col-sm-6">
                <DetailsCard
                    title={'Pedidos Manuales'}
                    loading={loading}
                    icon='fa fa-box'
                    value={dashBoardSummary?.ordersCountByType?.manual || '--'}
                    gradient="gradient-12"
                />
            </div>
        </div>
    );
};

export default DashboardSummaryCards;
